import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(200);
  const tickerRef = useRef(null);

  const toRotate = useMemo(() => ["He", "HCI Designer", "UI/UX Designer"], []); // 使用 useMemo

  const period = 2000;

  const tick = useCallback(() => {
    const i = loopNum % toRotate.length;
    const fullText = toRotate[i];
    const updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(100); // 删除速度加快
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period); // 停顿后开始删除
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500); // 恢复速度
    }
  }, [isDeleting, loopNum, text, toRotate, period]); // 确保 useCallback 的依赖项完整

  useEffect(() => {
    if (tickerRef.current) clearTimeout(tickerRef.current);

    tickerRef.current = setTimeout(() => {
      tick();
    }, delta);

    return () => clearTimeout(tickerRef.current);
  }, [tick, delta]);

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1>{`Hi! I'm WANG Ziguang`}</h1>
                  <h2 className="txt-rotate">
                    <span className="wrap">{text}</span>
                  </h2>
                  <p>My aspiration is to pioneer the creation of innovative, inclusive, and emotionally resonant solutions that seamlessly blend cutting-edge technologies with human-centered design.</p>
                  <button onClick={() => console.log('connect')}>
                    Let's connect <ArrowRightCircle size={25} />
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};